import isSameDay from "date-fns/isSameDay";
import { format, utcToZonedTime } from "date-fns-tz";

import logger from "@/utils/logger";

const isTimeValid = (str: string) => {
  if (str != null) {
    const date = new Date(str);
    return !isNaN(date.getTime());
  }

  return false;
};

const humanizeDateRange = (
  timeStart: string,
  timeEnd: string,
  timezone: string
): [string?, string?] => {
  if (!isTimeValid(timeStart) || !isTimeValid(timeEnd)) {
    return [];
  }

  const startDate = utcToZonedTime(timeStart, timezone);
  const endDate = utcToZonedTime(timeEnd, timezone);

  try {
    if (isSameDay(startDate, endDate)) {
      const dateLeft = format(startDate, "MMM d, h:mma", {
        timeZone: timezone,
      });
      const dateRight = format(endDate, "h:mma z", { timeZone: timezone });
      return [dateLeft, dateRight];
    }

    const dateLeft = format(startDate, "MMM d, h:mma", { timeZone: timezone });
    const dateRight = format(endDate, "MMM d, h:mma z", { timeZone: timezone });

    return [dateLeft, dateRight];
  } catch (error) {
    logger.error(error, {
      details: "error while parsing event date range",
      arguments: [timeStart, timeEnd],
    });
  }

  return [];
};

export default humanizeDateRange;
